export const ADMIN_PRODUCT_NAME = 'OneStem'

export function getAdminProductName(): string {
  return import.meta.env.VITE_APP_NAME?.trim() || ADMIN_PRODUCT_NAME
}

export const ONE_STEM_COLORS = Object.freeze({
  amethyst: '#9C7CA5',
  periwinkle: '#ADB2D3',
  mint: '#EBF5EE',
  yellow: '#D8B328',
  charcoal: '#414042',
  ink: '#1C1B1D',
  interactionLight: '#684F6F',
  interactionDark: '#C1AEC7',
  action: '#82658A',
  actionHover: '#684F6F',
  actionPressed: '#4E3B54',
})
